// extracted by mini-css-extract-plugin
export default {"container":"TradeFairEvents_container__37P8f","action":"TradeFairEvents_action__IxN-1","actionText":"TradeFairEvents_actionText__urjeh"};